import { capitalise } from '../text/helpers';

export function parseThemeSlug(slug: string) {
  const keywords = slug.replaceAll('-', ' ');
  const title = capitalise(keywords);
  return { title, keywords };
}

const THEME_PAGE_REGEXP =
  /^(?:\/([a-z]+))?\/theme\/[-_a-zA-Z0-9]+\/?(?:\?.*)?$/;

export function isThemePage(path: string) {
  return THEME_PAGE_REGEXP.test(path);
}
